import ToggleAccordion from "./components/website/ToggleAccordion";
import ContactForm from "./components/website/contactForm";
import { sendEventToAnalytics } from "./helpers/common-helpers";

window.addEventListener('DOMContentLoaded', () => {
    new ToggleAccordion();
    new ContactForm();

    // Track the contact-form view when the pricing-page popup is opened
    // (the form is hidden until then). PopupClass fires vsPopupBeforeOpen only
    // on a real open, so this won't double-count.
    document.addEventListener('vsPopupBeforeOpen', (e) => {
        if (!e.detail || !e.detail.popup || e.detail.popup.id !== 'pricing-contact-us-popup') return;
        sendEventToAnalytics('open_form_contact');
    });
});